module.exports = __webpack_public_path__ + "static/media/returnexample.f5f225d5.png";